/**
 * Note:
 * Default props
 * - These will likely move to design-system on a later date
 */
var defaultProps = {
  _hover: {
    bg: 'surface-hover'
  },
  _active: {
    bgColor: 'surface-active'
  },
  _expanded: {
    bgColor: 'surface-selected'
  },
  textStyle: 'ui-compact',
  borderRadius: 'lg',
  display: 'list-item',
  py: 'xs',
  p: 'sm'
};
export { defaultProps };